import { useCallback, useMemo } from 'react';
import { useExcelExport } from './useExcelExport';

export interface ExportSurveyActivityArgs {
    surveyId: string;
}

interface UseExportSurveyActivityResult {
    exporting: boolean;
    exportError: Error | undefined;
    exportActivityLog: (surveyId: string) => Promise<void>;
}

export const useExportSurveyActivity = (): UseExportSurveyActivityResult => {
    const config = useMemo(
        () => ({
            notificationId: (args: ExportSurveyActivityArgs) =>
                `survey-activity-export-${args.surveyId}`,
            loadingTitle: 'Exporting Activity Log',
            loadingMessage: 'Please wait while we generate the activity log',
            successTitle: 'Export Successful',
            successMessage: 'Activity log has been downloaded.',
            failedTitle: 'Export Failed' as const,
            filenamePrefix: 'activity_log',
            exportPath: '/export/price-survey-activity',
            buildBody: ({ surveyId }: ExportSurveyActivityArgs) => ({
                surveyId,
            }),
        }),
        [],
    );

    const { exporting, exportError, runExport } =
        useExcelExport<ExportSurveyActivityArgs>(config);

    const exportActivityLog = useCallback(
        async (surveyId: string) => {
            await runExport({ surveyId });
        },
        [runExport],
    );

    return {
        exporting,
        exportError,
        exportActivityLog,
    };
};
